export default __webpack_public_path__ + "assets/ico_launch-348183e4.svg";